(function () {
  'use strict';

  if (window.__rbOptionLabelBooted) {
    return;
  }

  window.__rbOptionLabelBooted = true;

  var ROOT =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  var ITEM_SELECTOR = '.rb-item[data-rb-item-id]';
  var TITLE_SELECTOR = '.rb-title';

  var labelById = new Map();
  var handleById = new Map();
  var inFlightById = new Map();
  var resolvedIds = new Set();
  var scheduled = false;

  function normalize(str) {
    return (str || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getItemId(item) {
    return String(item.getAttribute('data-rb-item-id') || '').trim();
  }

  function getItemTitle(item) {
    var titleNode = item.querySelector(TITLE_SELECTOR + ' span');
    if (titleNode && titleNode.textContent) {
      return titleNode.textContent.trim();
    }

    var aria = item.getAttribute('aria-label');
    return aria ? aria.trim() : '';
  }

  function upsertLabel(item, text) {
    if (!text) {
      return;
    }

    var title = item.querySelector(TITLE_SELECTOR);
    if (!title) {
      return;
    }

    var current = title.getAttribute('data-rb-option-label') || '';
    if (current === text) {
      return;
    }

    title.setAttribute('data-rb-option-label', text);
    item.setAttribute('data-rb-option-label', text);
  }

  function injectKnownLabels() {
    var items = document.querySelectorAll(ITEM_SELECTOR);
    items.forEach(function (item) {
      var id = getItemId(item);
      if (!id || !labelById.has(id)) {
        return;
      }

      upsertLabel(item, labelById.get(id));
    });
  }

  function lookupProductByTitle(id, title) {
    var searchTerm = title || id;
    var url =
      ROOT +
      'search/suggest.json?q=' +
      encodeURIComponent(searchTerm) +
      '&resources[type]=product&resources[limit]=10';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search failed for bundle product.');
        }

        return response.json();
      })
      .then(function (data) {
        var products =
          data &&
          data.resources &&
          data.resources.results &&
          Array.isArray(data.resources.results.products)
            ? data.resources.results.products
            : [];

        if (!products.length) {
          return null;
        }

        var byId = products.find(function (product) {
          return String(product.id) === id;
        });

        if (byId) {
          return byId;
        }

        var normalizedTitle = normalize(title);
        var byTitle = products.find(function (product) {
          return normalize(product.title) === normalizedTitle;
        });

        return byTitle || products[0];
      })
      .catch(function () {
        return null;
      });
  }

  function fetchLabelByHandle(handle) {
    var endpoint = ROOT + 'products/' + encodeURIComponent(handle) + '?view=rb-option-a-label';

    return fetch(endpoint, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Label endpoint request failed.');
        }

        return response.json();
      })
      .then(function (payload) {
        if (!payload || typeof payload.label !== 'string') {
          return '';
        }

        return payload.label.trim();
      })
      .catch(function () {
        return '';
      });
  }

  function resolveLabel(id, title) {
    if (labelById.has(id)) {
      return Promise.resolve(labelById.get(id));
    }

    if (inFlightById.has(id)) {
      return inFlightById.get(id);
    }

    var promise = (handleById.has(id)
      ? Promise.resolve({ handle: handleById.get(id) })
      : lookupProductByTitle(id, title)
    )
      .then(function (productMatch) {
        if (!productMatch || !productMatch.handle) {
          return '';
        }

        handleById.set(id, productMatch.handle);
        return fetchLabelByHandle(productMatch.handle);
      })
      .then(function (label) {
        labelById.set(id, label || '');
        resolvedIds.add(id);

        return label;
      })
      .catch(function () {
        resolvedIds.add(id);
        return '';
      })
      .finally(function () {
        inFlightById.delete(id);
      });

    inFlightById.set(id, promise);
    return promise;
  }

  function collectPendingItems() {
    var items = Array.prototype.slice.call(document.querySelectorAll(ITEM_SELECTOR));

    return items.filter(function (item) {
      var id = getItemId(item);
      if (!id) {
        return false;
      }

      if (resolvedIds.has(id)) {
        return false;
      }

      if (labelById.has(id) || inFlightById.has(id)) {
        return false;
      }

      return true;
    });
  }

  function processItems() {
    injectKnownLabels();

    var pending = collectPendingItems();
    if (!pending.length) {
      return;
    }

    pending.forEach(function (item) {
      var id = getItemId(item);
      var title = getItemTitle(item);

      resolveLabel(id, title).then(function (label) {
        if (label) {
          upsertLabel(item, label);
        }
      });
    });
  }

  function scheduleProcess() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      processItems();
    });
  }

  function startObserver() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleProcess();
          return;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function boot() {
    scheduleProcess();
    startObserver();

    // Recharge can paint asynchronously after initial mount; poll briefly.
    var retries = 0;
    var maxRetries = 15;
    var interval = window.setInterval(function () {
      scheduleProcess();
      retries += 1;

      if (retries >= maxRetries) {
        window.clearInterval(interval);
      }
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
